import { render } from "./NachrichtenLink.pug?vue&type=template&id=4c1f7e32&lang=pug"
import script from "./NachrichtenLink.js?vue&type=script&lang=js"
export * from "./NachrichtenLink.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__